import AllPendingHodLeaveRequest from "../../components/hod/all-pending-hod-leave-request";
import Layout from "../../components/Layout";

function AllPendingHodLeaveRequestPage() {
  return (
    <>
      <div>
        <Layout>
          <AllPendingHodLeaveRequest />
        </Layout>
      </div>
    </>
  );
}
export default AllPendingHodLeaveRequestPage;
